import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';
import {Fragment} from 'react';

export const CohortFormPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = () => {
  return <Fragment />;
};
